<template>
    <v-text-field
        ref="option"
        :key="key"
        :model-value="value"
        :name="name"
        :label="label"
        append-icon="mdi-plus"
        prepend-icon="mdi-minus"
        type="number"
        :min="min"
        :max="max"
        class="input--no-arrows"
        @click:append="increment"
        @click:prepend="decrement"
        @update:model-value="update"
    />
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class NumberOption extends Vue {
        @Prop({required: true}) name
        @Prop() label
        @Prop({default: 0, type: Number}) min
        @Prop({default: 7, type: Number}) max

        key = 0
        value = 0

        created() {
            this.value = this.$route.query[this.name] ? +this.$route.query[this.name] : this.min
        }

        update(v) {
            let value = !v ? this.min : v.length > 1 && +v > this.max ? +v.slice(0, -1) : +v
            if (value < this.min) value = this.min
            else if (value > this.max) value = this.max
            if (this.value === value) {
                this.key++
            }
            this.value = value
        }

        increment() {
            if (this.value === this.max) return
            this.value = this.value + 1
        }

        decrement() {
            if (this.value === this.min) return
            this.value = this.value - 1
        }
    }

    export default NumberOption
</script>
